import { css, SerializedStyles } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export

export const container = css`
  background-color: #fafbfc;
  padding-bottom: 100px;
  padding-top: 20px;
`;

export const illustration = css`
  width: 280px;
  height: 140px;
  ${media('>=desktop')} {
    width: 345px;
    height: 174px;
  }
`;

export const ideaList = css`
  list-style: none;
  position: relative;
  height: 150px;
`;
export const ideaListItem = (
  isActive: boolean,
  itemNumber: number,
): SerializedStyles => css`
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
  height: 150px;
  ::before {
    content: '•';
    font-size: 24px;
    position: absolute;
    top: 180px;
    left: ${itemNumber * 18}px;
    color: ${(isActive && `${variables.colour.neutral800}`) ||
    `${variables.colour.neutral400}`};
  }
`;

export const ideaContent = (isActive: boolean): SerializedStyles => css`
  height: 150px;
  display: ${(isActive && 'block') || 'none'};
  visibility: ${(isActive && 'normal') || 'hidden'};
  ${(isActive && 'animation: fade 1s') ||
  'transition: opacity 600ms, visibility 600ms'};
  font-size: 16px;
  line-height: 24px;
  @keyframes fade {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  p {
    padding-bottom: 24px;
  }
  strong {
    font-weight: 700;
  }
  ul {
    list-style: disc;
    padding-left: 18px;
  }
  ${media('>=tablet')} {
    max-width: 330px;
  }
  ${media('>=desktop')} {
    max-width: 520px;
  }
`;

export const inspirationGrid = css`
  display: grid;
  grid-gap: 0px;
  grid-template-areas:
    'inspirationheader'
    'inspirationlist';
  grid-template-columns: 1fr;
  grid-template-rows: 48px 1fr;
  ${media('>=tablet')} {
    display: grid;
    grid-template-areas:
      'inspirationheader inspirationheader'
      'inspirationlist inspirationimage';
    grid-template-columns: 1fr 300px;
  }
  ${media('>=desktop')} {
    grid-template-areas:
      'inspirationheader inspirationimage'
      'inspirationlist inspirationimage';
    grid-template-columns: 1fr 360px;
    grid-template-rows: 74px 1fr;
  }
`;
export const inspirationHeaderGrid = css`
  grid-area: inspirationheader;
  padding-bottom: 18px;
  ${media('>=desktop')} {
    padding-bottom: 26px;
  }
`;
export const inspirationListGrid = css`
  grid-area: inspirationlist;
`;
export const inspirationImageGrid = css`
  grid-area: inspirationimage;
  display: none;
  ${media(`>=tablet`)} {
    width: 280px;
    height: 140px;
    display: block;
  }
  ${media('>=desktop')} {
    width: 345px;
    height: 174px;
    padding-top: 26px;
  }
`;
